const xlsx  = require('xlsx')
const downF  = require('../helpers/downloadFile')

module.exports = async function (path) {
    var file = await downF(path)
    const XLSX = xlsx
    var readingsDespA = await getReadingsDesp(file, XLSX, 1)
    var readingsDespB = await getReadingsDesp(file, XLSX, 2)
  
    var readingsStadistcA = await getReadingsStadistcs(file, XLSX, 1);
    var readingsStadistcB = await getReadingsStadistcs(file, XLSX, 2);
  
    var seriesA = await formatReadingsDesp(readingsDespA, 'a')
    var seriesB = await formatReadingsDesp(readingsDespB, 'b')
  
    var seriesAStadistc = await formatReadingsStatidstc(readingsStadistcA, 'a')
    var seriesBStadistc = await formatReadingsStatidstc(readingsStadistcB, 'b')
  
    var series = []
    
    for (const key in seriesA) {
      if (seriesA.hasOwnProperty.call(seriesA, key)) {
        const element = seriesA[key];
        series.push({
          [key] : element,
        })
      }
    }
  
    for (const key in seriesB) {
      if (seriesB.hasOwnProperty.call(seriesB, key)) {
        const element = seriesB[key];
        series.push({
          [key] : element,
        })
      }
    }
  
    for (const key in seriesAStadistc) {
      if (seriesAStadistc.hasOwnProperty.call(seriesAStadistc, key)) {
        const element = seriesAStadistc[key];
        series.push({
          [key] : element,
        })
      }
    }
  
    for (const key in seriesBStadistc) {
      if (seriesBStadistc.hasOwnProperty.call(seriesBStadistc, key)) {
        const element = seriesBStadistc[key];
        series.push({
          [key] : element,
        })
      }
    }
  
    return series
}

async function getReadingsDesp(workbook, XLSX, page) {
    const wsname = workbook.SheetNames[page]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
    var obj2List = [];
    var obj3List = [];
    var stopnum = 0;
    var precision = 0;
    var limit = limit;
    var headersSeries = [];
    var SeriesData = [];
    var contTb = 0;
    var stopCount = true;
  
    for (let index = 0; index < ws.length; index++) {
      if (index == 0) {
        var notFinishSeries = true;
        for (const property in ws[index]) {
          if (
            ws[index][property] == "Variación" ||
            ws[index][property] == "VARIACIÓN"
          ) {
            notFinishSeries = false;
          } else {
            if (
              ws[index][property] !== "PROFUNDIDAD EN (m)" &&
              notFinishSeries
            ) {
              headersSeries.push(ws[index][property]);
              stopnum++;
              precision++;
            } else {
              if (
                ws[index][property] === "Precisión" ||
                ws[index][property] === "Precisón"
              ) {
                break;
              } else {
                precision++;
              }
            }
          }
        }
      }
  
      if (ws[index]["__EMPTY"] === "PROFUNDIDAD EN (m)") {
        contTb++;
      }
      if (contTb > 2) {
        if (ws.length > index + 1) {
          if (ws[index + 1]["__EMPTY"] !== "Variación máxima en (mm)") {
            if (
              ws[index + 1]["__EMPTY"] !== "Variación mínima en (mm)" &&
              stopCount
            ) {
              Object.values(ws[index + 1]).forEach((element, key) => {
                if (key > 0 && key <= stopnum) {
                  var obj3 = {
                    name: ws[index + 1]["__EMPTY"],
                    x: new Date(headersSeries[key - 1]).toDateString(
                      "yyyy-MM-dd hh:mm:ss"
                    ),
                    y: element,
                  };
                  obj3List.push(obj3)
                }
              });
            } else {
              stopCount = false;
            }
          }
        }
      }
    }
  
    stopnum = 0;
    precision = 0;
    headersSeries = [];
    SeriesData = [];
    contTb = 0;
  
    for (var i = 0; i <= ws.length; i++) {
      if (i == 0) {
        var notFinishSeries = true;
        for (const property in ws[i]) {
          if (
            ws[i][property] == "Variación" ||
            ws[i][property] == "VARIACIÓN"
          ) {
            notFinishSeries = false;
          } else {
            if (ws[i][property] !== "PROFUNDIDAD EN (m)" && notFinishSeries) {
              headersSeries.push(ws[i][property]);
              stopnum++;
              precision++;
            } else {
              if (
                ws[i][property] === "Precisión" ||
                ws[i][property] === "Precisón"
              ) {
                break;
              } else {
                precision++;
              }
            }
          }
        }
      }
      var close = true;
      if (ws[i] != null) {
        if (i > 0 && ws[i]["__EMPTY"] !== "Variación máxima en (cm)" && close) {
          var cont = 0;
          Object.values(ws[i]).forEach((element, key) => {
            if (key <= stopnum && key > 0) {
              var obj2 = {
                name: ws[i]["__EMPTY"],
                x: new Date(headersSeries[key - 1]).toDateString(
                  "yyyy-MM-dd hh:mm:ss"
                ),
                y: element,
              };
              obj2List.push(obj2);
              cont++;
            }
          });
        } else {
          if (ws[i]["__EMPTY"] === "Variación máxima en (cm)") {
            close = false;
          }
        }
  
        for (let index = 0; index <= stopnum; index++) {
          if (index == 0) {
            if (
              !isNaN(ws[i]["__EMPTY"]) &&
              !isNaN(ws[i]["__EMPTY_" + (2 + index)])
            ) {
              var obj = {
                name: headersSeries[index],
                y: ws[i]["__EMPTY"],
                x: ws[i]["__EMPTY_" + (2 + index)],
              };
              limit = ws[i]["__EMPTY_" + (4 + precision)]
              SeriesData.push(obj)
            } 
          } else {
            if (ws[i]["__EMPTY"] !== "Variación máxima en (cm)") {
              if (
                !isNaN(ws[i]["__EMPTY"]) &&
                !isNaN(ws[i]["__EMPTY_" + (2 + index)])
              ) {
                if (ws[i]["__EMPTY"] !== "Variación máxima en (mm)") {
                  var obj = {
                    name: headersSeries[index],
                    y: ws[i]["__EMPTY"],
                    x: ws[i]["__EMPTY_" + (2 + index)],
                  };
                  SeriesData.push(obj);
  
                  if (ws[i]["__EMPTY"] == "Variación máxima en (mm)") {
                    index = stopnum + 1
                    i = ws.length;
                  }
                } else {
                  index = stopnum + 1
                  i = ws.length
                }
              } 
            } else {
              index = stopnum + 1
              i = ws.length
            }
          }
        }
      }
    }
  
    const groupByKey = (list, key, {
        omitKey = false
      }) =>
      list.reduce(
        (hash, {
          [key]: value,
          ...rest
        }) => ({
          ...hash,
          [value]: (hash[value] || []).concat(
            omitKey ? {
              ...rest
            } : {
              [key]: value,
              ...rest
            }
          ),
        }), {}
      );
  
    var cars = SeriesData;
  
    var agroupSeriesObj2 = groupByKey(obj2List, "name", {
      omitKey: false,
    });
  
    var agroupSeriesObj3 = groupByKey(obj3List, "name", {
      omitKey: false,
    });
  
    var agroupSeries = groupByKey(cars, "name", {
      omitKey: true,
    });
  
    var arrayAgroupSeries = [
      agroupSeries,
      agroupSeriesObj2,
      agroupSeriesObj3,
    ];
  
    return arrayAgroupSeries
  }
  
  async function getReadingsStadistcs(workbook, XLSX, page) {
    //getLadoA(1)
    const wsname = workbook.SheetNames[page]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
    const excellist = []; // Clear received data
    // Edit data
    //seriesA
    var stopnum = 0;
    var precision = 0;
    var limit = limit;
    var headersSeries = [];
    var indexSeries = [];
    var SeriesData = [];
    var contTb = 0;
  
    for (var i = 0; i < ws.length; i++) {
      if (i == 0) {
        var notFinishSeries = false;
        for (const property in ws[i]) {
          precision++;
          if (ws[i][property] === "Máximo" || notFinishSeries) {
            notFinishSeries = true;
            headersSeries.push(ws[i][property]);
            indexSeries.push(property);
            if (ws[i][property] !== "Precisión") {
              stopnum++;
            } else {
              notFinishSeries = false;
            }
          } else if (ws[i][property] === "Precisión") {
            indexSeries.push(property);
            notFinishSeries = false;
            break;
          }
        }
      }
  
      for (let index = 0; index < stopnum; index++) {
        if (index == 0) {
          if (
            !isNaN(ws[i]["__EMPTY"]) &&
            !isNaN(ws[i]["__EMPTY_" + (precision + 1)])
          ) {
            var obj = {
              name: headersSeries[index],
              y: ws[i]["__EMPTY"],
              x: ws[i][indexSeries[index]],
            };
            limit = ws[i]["__EMPTY_" + (1 + precision)];
            SeriesData.push(obj);
          }
        } else {
          if (!isNaN(ws[i]["__EMPTY"]) && !isNaN(ws[i][indexSeries[index]])) {
            var obj = {
              name: headersSeries[index],
              y: ws[i]["__EMPTY"],
              x: ws[i][indexSeries[index]],
            };
            SeriesData.push(obj);
          }
        }
      }
    }
  
    const groupByKey = (list, key, { omitKey = false }) =>
      list.reduce(
        (hash, { [key]: value, ...rest }) => ({
          ...hash,
          [value]: (hash[value] || []).concat(
            omitKey ? { ...rest } : { [key]: value, ...rest }
          ),
        }),
        {}
      );
    var cars = SeriesData;
    var agroupSeries = groupByKey(cars, "name", {
      omitKey: true,
    });
    return agroupSeries;
  }
  
  async function formatReadingsDesp(arrayAgroupSeries, lado){
    var agroupA = arrayAgroupSeries[0];
    var agroupTerrenoA = arrayAgroupSeries[1];
    var agroupVelocidadA = arrayAgroupSeries[2];
    var seriesA = []
    var seriesActuales = []
    var seriesActualesStatus = []
    var seriesDesplazamientoHzA = []
    var seriesVelocidadA = []
    
  
    for (const nameSerie in agroupA) {
      var arraYl = Array.from(agroupA[nameSerie])
      var arrayFix = []
      for (let index = 0; index < arraYl.length; index++) {
        if (arraYl[index].x !== null && arraYl[index].y !== null) {
          arrayFix.push(arraYl[index])
        }
      }
  
      if (nameSerie.includes("(hora estándar de Colombia)")) {
        var date = new Date(nameSerie)
        var mes = date.getMonth() + 1
        var dia = date.getDate()
  
        var formatFecha = date.getFullYear() + "-" + mes + "-" + dia;
  
        seriesActuales.push({
          name: formatFecha,
          status: "enable",
        });
  
        for (
          let index = 0; index < seriesActualesStatus.length; index++
        ) {
          const element = seriesActualesStatus[index];
          if (
            element.serie == formatFecha &&
            element.status == "disable"
          ) {
            formatFecha = formatFecha + "**";
          }
        }
  
        seriesA.push({
          name: formatFecha,
          data: arrayFix,
        });
      } else {
        seriesA.push({
          name: nameSerie,
          data: arrayFix,
        });
      }
    }
  
    for (const property in agroupTerrenoA) {
      if (property.includes(".")) {
        agroupTerrenoA[property].forEach((element, index) => {
          var date = new Date(Date.parse(element.x));
          var dateText =
            date.getFullYear() +
            "-" +
            date.getMonth() +
            "-" +
            date.getDate();
          agroupTerrenoA[property][index].x = dateText
        });
        seriesDesplazamientoHzA.push({
          name: property,
          data: agroupTerrenoA[property],
        });
      }
    }
  
    for (const property in agroupVelocidadA) {
      agroupVelocidadA[property].forEach((element, index) => {
        var date = new Date(Date.parse(element.x));
        var dateText =
          date.getFullYear() +
          "-" +
          date.getMonth() +
          "-" +
          date.getDate();
        agroupVelocidadA[property][index].x = dateText
      });
  
      if (property.includes(".")) {
        seriesVelocidadA.push({
          name: property,
          data: agroupVelocidadA[property],
        });
      }
    }
  
    if(lado === 'a'){
      var readings = {
        'desplazamientoA': seriesA,
        'desplazamientoHorizontalA': seriesDesplazamientoHzA,
        'velocidadA': seriesVelocidadA
      }
    
      return readings
    }else if(lado === 'b'){
      var readings = {
        'desplazamientoB': seriesA,
        'desplazamientoHorizontalB': seriesDesplazamientoHzA,
        'velocidadB': seriesVelocidadA
      }
      return readings
    }
    else {
      return null
    }
  }
  
  async function formatReadingsStatidstc(arrayAgroupSeries, lado){
    var seriesStadists = []
    for (const nameSerie in arrayAgroupSeries) {
      if (nameSerie != "PRECISIÓN" && nameSerie != "Precisón") {
        seriesStadists.push({
          name: nameSerie,
          data: Array.from(arrayAgroupSeries[nameSerie]),
        });
      }
    }
  
    if(lado === 'a'){
      var obj = {
        "Cortes estadisticos lado A": seriesStadists
      }
      return obj
    }
    else if (lado === 'b'){
      var obj = {
        "Cortes estadisticos lado B": seriesStadists
      }
      return obj
    }
    else {
      return null
    }
  }